import React, {Component} from 'react';
import {Card, CardBody, Col, Button, ButtonGroup} from 'reactstrap';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {withTranslation} from "react-i18next";
import LoadingIcon from "mdi-react/LoadingIcon";
import withErrorNotification from "../../../hof/withErrorNotification";
import {Wallet} from "../../../services/Wallet";
import Notifications from "../../../hof/notifications";
import {fetchAccountStats} from '../../../redux/actions/steemAccountActions';
import AssetIndicator from "../../Overview/components/AssetIndicator";
import {translate} from "../../../translations/i18n";

class Rewards extends Component {

    constructor() {
        super();
        this.state = {
            inProgress: false,
        }
    }

    claimRewards = async (username) => {
        await withErrorNotification(async () => {
            this.setState({inProgress: true});
            const result = await Wallet.claimRewards(username);
            console.log(result);
            Notifications.showNotification(translate('wallet.rewards.notifications.claimed.title'), translate('wallet.rewards.notifications.claimed.body'), Notifications.Colors.SUCCESS);
            this.setState({inProgress: false});
        }, () => {
            this.setState({inProgress: false});
        })
    }

    render() {

        const {t} = this.props;

        const {reward_hive, reward_hive_power, reward_hbd} = this.props.steemAccount;

        return (
            <Col md={12} lg={12} xl={12}>
                <Card className="card--not-full-height">
                    <CardBody>
                        <div className="card__title">
                            <h5 className="bold-text">{t('wallet.rewards.title')}</h5>
                            <h5 className="subhead">{t('wallet.rewards.subtitle')}</h5>
                        </div>
                        <div className="card__body">
                            {(parseFloat(reward_hive_power) || parseFloat(reward_hive) || parseFloat(reward_hbd))
                                ?
                                <>
                                    <div>
                                        {reward_hive_power > 0 && <AssetIndicator
                                            amount={reward_hive_power}
                                            asset='Hive power'
                                            color_name="red"
                                        />}
                                        {reward_hive > 0 && <AssetIndicator
                                            amount={reward_hive}
                                            asset='HIVE'
                                            color_name="green"
                                        />}
                                        {reward_hbd > 0 && <AssetIndicator
                                            amount={reward_hbd}
                                            asset='HBD'
                                            color_name="blue"
                                        />}
                                    </div>

                                    <ButtonGroup className="btn-group--justified">
                                        <Button
                                            size="sm"
                                            outline
                                            color="primary"
                                            onClick={async () => {
                                                await this.claimRewards(this.props.auth.username)
                                                this.props.onClaimRewards(this.props.auth.username);
                                            }}
                                            className="expand expand--load"
                                        >
                                            {this.state.inProgress && <LoadingIcon/>}
                                            {t('wallet.rewards.button_claim')}
                                        </Button>
                                    </ButtonGroup></>
                                : <p>{ t('wallet.rewards.no_rewards_to_claim')}</p>}
                        </div>
                    </CardBody>
                </Card>
            </Col>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        steemAccount: state.steemAccount,
        auth: state.auth
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onClaimRewards: (username) => dispatch(fetchAccountStats(username))
    }
}

Rewards = withRouter(connect(mapStateToProps, mapDispatchToProps)(Rewards));

export default withTranslation('dashboard')(Rewards);
